export class Portfolio {
    id: string;
    name: string;
    defaultPortfolio: boolean;
    parks: Array<string>;

    constructor(
        id?: string,
        name?: string,
        defaultPortfolio?: boolean,
        parks?: Array<string>
    ) {
        this.id = id;
        this.name = name;
        this.defaultPortfolio = defaultPortfolio;
        this.parks = parks;
    }
}